import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {useOpenModals} from 'context/openModals';

function DiscardChangesModalSheet() {
  const {t} = useTranslation();

  const {isOpenDiscardModal, closeDiscardModal, discardChangesAndRestart} =
    useOpenModals();
  const discardCompleteChangesText = React.useMemo(
    () => (
      <Trans i18nKey="discard_data_leaving_the_process">
        Leaving the process before completing the registration will
        <b>discard your personal data</b> so you will have to complete the from again.
      </Trans>
    ),
    [],
  );

  return (
    <ResponsiveSheet
      open={isOpenDiscardModal}
      onClose={closeDiscardModal}
      title={t('discard_data')}
      className="discard-changes-modal"
      dialogClassName="!max-w-[460px]"
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
    >
      <div className="flex flex-col gap-8">
        <p className="text-center text-sm text-gray-700">{discardCompleteChangesText}</p>
        <div className="flex flex-col gap-5 max-w-[375px] mx-auto">
          <Button onClick={discardChangesAndRestart}>
            {t('discard_changes_leaving')}
          </Button>
          <Button variant="link" onClick={closeDiscardModal}>
            {t('continue_process')}
          </Button>
        </div>
      </div>
    </ResponsiveSheet>
  );
}

export {DiscardChangesModalSheet};
